<template>
  <div class="k-invitation-list">
    <div
      v-for="invitation in invitations"
      :key="invitation.id"
      :class="cssMode"
      class="k-participant"
    >
      <div class="k-participant-icons">
        <div class="k-participant-icon">
          <font-awesome-icon
            class="pb-0"
            size="xs"
            color=""
            :icon="['fal', 'envelope-open']"
            v-if="invitation.visited"
          />
          <font-awesome-icon
            class="pb-0"
            size="xs"
            :icon="['fal', 'envelope']"
            v-else
          />
        </div>
        <div class="k-participant-icon">
          <i
            class="fas fa-cog fa-1x k-p-icon"
            v-if="invitation.showCogIcon"
          ></i>
        </div>
      </div>
      <div class="k-participant-details">
        <div class="k-invvitation-email text-standard  text-weight-regular align-self-start">
          {{ invitation.email }}
        </div>
      </div>
      <slot />
    </div>
    
  </div>
</template>
<script>
export default {
  name: 'RendererInvitations',
  props: ['invitations', 'cssMode'],
};
</script>

<style lang="scss">
.k-invitation-list {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
}

.k-invvitation-email {
  white-space: nowrap;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.k-invitation-row {
  display: flex;
  flex-grow: 1;
  justify-content:center;
  align-items: center;

}


</style>
